import { render, staticRenderFns } from "./_Bottarget.vue?vue&type=template&id=58cdc99d"
import script from "./_Bottarget.vue?vue&type=script&lang=js"
export * from "./_Bottarget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports